/** Matches the catalog entry in consent-catalog.constants.ts. */
export const CHATWERK_SERVICE_ID = 'chatwerk';

/** The versioned loader the embed code from the ChatWerk portal points at. */
export const CHATWERK_LOADER_URL = 'https://cdn.chatwerk.de/1.0.0/chatwerk-loader.min.js.gz';

/** Matches the launcher's `data-chatwerk-trigger` — ChatWerk binds its open handler to it. */
export const CHATWERK_TRIGGER_SELECTOR = '[data-chatwerk-trigger]';

/** What ChatWerk mounts into <body> while the chat is open: the wrapper and its frame. */
export const CHATWERK_WINDOW_ID = 'web-chat-wrapper-root';
export const CHATWERK_FRAME_ID = 'chatwerk-iframe';

export const CHAT_WIDGET_COPY = {
    open: 'Chat öffnen',
    close: 'Schließen',
    consentTitle: 'Chat starten',
    consentText:
        'Für den Chat laden wir den Dienst ChatWerk der Inbox Solutions GmbH. Dabei werden unter anderem Ihre IP-Adresse und Geräteinformationen übertragen; die Server betreibt Google Cloud.',
    privacyPrefix: 'Mehr dazu in unserer',
    privacyLinkText: 'Datenschutzerklärung',
    start: 'Chat starten',
    errorTitle: 'Chat nicht erreichbar',
    errorText: 'Der Chat konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
    frameTitle: 'Chat',
    /** First message in the chat window, as set in the portal's embed code. */
    welcomeMessage: 'Guten Tag, wie können wir Ihnen helfen?',
} as const;
